import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useSettingsVaccineCodes = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["settingsVaccineCodes", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/vaccine-codes/all`);
      return response?.data ?? [];
    },
    enabled: !!tenantVal,
  });
};
